import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
import * as Solr from "../../3x1010/Solr.js";

export default class PageSolrAdvancedStandard extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.showPreloader(false);
    Pqp.trace("PageSolrAdvancedStandard - Hello world");

    // dispaccio un evento globale
    try {
      this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
    } catch (error) {
      // console.log(error);
    }
    // solr quqry
    this.collectionName = "ARCHIVI_coll";
    this.schema = null;
    this.lastRq = null;
    //this.fields = [];
    this.query = null;
    this.MAX_NESTED_QUERIES = 10;
    // campi
    this.initFields();
    //
    $(".wlfInfo").text(this.collectionName);
    $(".wlfSearch").on("click", this.onSearch.bind(this, false));
    $("body").keydown(this.onSearch.bind(this, true));
    $(".wlfPrev").on("click", this.onMove.bind(this, -1));
    $(".wlfNext").on("click", this.onMove.bind(this, +1));
  }

  get isHomepage() {
    return true;
  }

  // ***********************************

  initFields() {
    this.schema = new Solr.Schema(this.collectionName);
    //var sel = $(".wlfField");
    //this.fields = this.schema.getAllFields(Solr.FieldFlags.FLAG_QUERY, 1);
    //console.log(this.fields);
    //
    this.query = new Solr.QueryNodeBoolean(this.schema.findFieldByPath("/"));
    //
    this.mcRoot = $("#wlfQueryBuilder");
    this.mcRoot.on("redraw", (e) => this.qbRedraw());
    this.mcRoot.trigger("redraw");
  }

  // ***********************************

  qbRedraw() {
    this.mcRoot.html("");
    this.qbPaintGenericNode(0, this.query);
  }

  qbPaintGenericNode(level, node) {
    //let str = node.Field._label;
    console.log(node);
    if (node instanceof Solr.QueryNodeBoolean) {
      this.qbPaintQueryNodeBoolean(level, node);
    } else if (node instanceof Solr.QueryNodeTerm) {
      this.qbPaintQueryNodeTerm(level, node);
    }
  }
  qbPaintQueryNodeBoolean(level, node) {
    let ctrl = $("#_QueryNodeBoolean").clone();
    ctrl.css("margin-left", level * 20 + "px");
    ctrl.attr("id", node.id);
    this.mcRoot.append(ctrl);
    //
    $("._path", ctrl).text(node.Field._label);
    $("._Occurency", ctrl).prop("checked", node.Occurency == Solr.QueryNodeOccurencyType.NOT);
    $("._Occurency", ctrl).on("click", () => {
      let v = $("._Occurency", ctrl).prop("checked");
      node.Occurency = !v ? Solr.QueryNodeOccurencyType.MUST : Solr.QueryNodeOccurencyType.NOT;
      this.mcRoot.trigger("redraw");
    });
    $("._btnRemove", ctrl).on("click", () => {
      this.qbRemoveNode(node);
      this.mcRoot.trigger("redraw");
    });
    //
    $("._Operator", ctrl).text(node.Operator);
    $("._Operator", ctrl).on("click", (e) => {
      node.toggleOperator();
      this.mcRoot.trigger("redraw");
    });
    $("._btnAddTerm", ctrl).on("click", () => {
      this._onAddSubNodeUi(ctrl, level + 1, node);
    });
    $("._btnAddBool", ctrl).on("click", () => {
      //node.Clauses.push(new Solr.QueryNodeBoolean(node.Field, false));
      this.qbAddSubNodeBool(node, new Solr.QueryNodeBoolean(node.Field, false));
      this.mcRoot.trigger("redraw");
    });
    // vincoli
    if (node.Operator == Solr.QueryNodeBooleanType.EXISTS) {
      $("._btnAddTerm", ctrl).hide();
      $("._btnAddBool", ctrl).hide();
    } else {
      $("._btnAddTerm", ctrl).show();
      if (level < this.MAX_NESTED_QUERIES) $("._btnAddBool", ctrl).show();
      else $("._btnAddBool", ctrl).hide();
    }
    // se root non posso rimuovere
    if (node == this.query) $("._btnRemove", ctrl).hide();
    // subnodes
    if (node.Operator != Solr.QueryNodeBooleanType.EXISTS) {
      for (let c of node.Clauses) {
        this.qbPaintGenericNode(level + 1, c);
      }
    }
  }

  qbPaintQueryNodeTerm(level, node) {
    let ctrl = $("#_QueryNodeTerm").clone();
    ctrl.css("margin-left", level * 20 + "px");
    ctrl.attr("id", node.id);
    this.mcRoot.append(ctrl);
    //
    $("._path", ctrl).text(node.Field._label);
    $("._Occurency", ctrl).prop("checked", node.Occurency == Solr.QueryNodeOccurencyType.NOT);
    $("._Occurency", ctrl).on("click", () => {
      let v = $("._Occurency", ctrl).prop("checked");
      node.Occurency = !v ? Solr.QueryNodeOccurencyType.MUST : Solr.QueryNodeOccurencyType.NOT;
      this.mcRoot.trigger("redraw");
    });
    $("._btnRemove", ctrl).on("click", () => {
      this.qbRemoveNode(node);
      this.mcRoot.trigger("redraw");
    });
    // data list id
    $("datalist", ctrl).attr("id", "Lookup_" + node.id);
    // val
    $("._Value", ctrl).val(node.Value);
    debugger;
    // carico gli operatori
    let sel = $("._Compare", ctrl);
    sel.find("option").remove().end();
    // becco lista di operatori
    for (let o of node.Operators) {
      var opt = $("<option></option>");
      opt.val(o);
      opt.text(o);
      if (o == node.Compare) opt.prop("selected", true);
      sel.append(opt);
    }
    if (Solr.QueryNodeCompareType.getNumArgs(node.Compare) <= 0) $("._Value", ctrl).hide();
    else $("._Value", ctrl).show();
    // cambio operatore
    sel.on("change", () => {
      node.Compare = sel.val();
      // se unario nascondo input
      if (Solr.QueryNodeCompareType.getNumArgs(node.Compare) <= 0) $("._Value", ctrl).hide();
      else $("._Value", ctrl).show();
    });
    // cambio valore
    $("._Value", ctrl).on("change", () => {
      node.Value = $("._Value", ctrl).val();
    });
    // se ho provider
    if (node.Field.Lookup) {
      $("._Value", ctrl).attr("list", "Lookup_" + node.id);
      //
      let selProv = $("#Lookup_" + node.id);
      for (let l of SolrLOOKUPS[node.Field.Lookup].Rows) {
        var opt = $("<option></option>");
        opt.val(l.Value);
        opt.text(l.Label);
        selProv.append(opt);
      }
    } else {
      $("_Value", ctrl).removeAttr("list");
    }
  }

  qbRemoveNode(node) {
    if (node.id != this.query.id) this.query.removeSubNodeById(node.id, true);
  }
  qbAddSubNodeBool(node, subNode) {
    node.addSubNode(subNode);
  }
  qbAddSubNodeTerm(node, pathToAdd) {
    let subField = this.schema.findFieldByPath(pathToAdd);
    if (subField == null) return;
    // se è un campo complesso
    if (subField.Type == Solr.FieldType.ComplexField) {
      node.addSubNode(new Solr.QueryNodeBoolean(subField, true));
    } else {
      node.addSubNode(new Solr.QueryNodeTerm(subField));
    }
  }

  _onAddSubNodeUi(ctrl, level, node) {
    $("._choose").hide();
    let mcList = $("._choose", ctrl);
    mcList.find("option").remove().end();
    mcList.show();
    //
    let flds = this.schema.getContextFields(node.Field._path, Solr.FieldFlags.FLAG_QUERY, level < this.MAX_NESTED_QUERIES, level < this.MAX_NESTED_QUERIES, true, true);
    console.log(flds.length);
    for (let f of flds) {
      let opt = $("<option></option>");
      let label = f._label;
      if (f.Relation) label += " (R)";
      else if (f.Type == Solr.FieldType.ComplexField) label += " (C)";
      else if (f.Lookup) label += " (L)";
      opt.val(f._path);
      opt.text(label);
      $("select", mcList).append(opt);
    }
    $("._yes", mcList).on("click", () => {
      this.qbAddSubNodeTerm(node, $("select", mcList).val());
      this.mcRoot.trigger("redraw");
    });
    $("._no", mcList).on("click", () => {
      mcList.hide();
    });
  }

  // ***********************************

  onMove(dir) {
    if (this.lastRq == null) return;
    //
    var pageSize = this.lastRq.options.RowsNum;
    var maxStart = Math.max(0, Math.ceil(this.lastRq.TotalRows / pageSize) - 1) * pageSize;
    var rqStart = this.lastRq.options.RowStart + dir * pageSize;

    if (rqStart < 0 || rqStart > maxStart) return;
    //
    this.lastRq.options.RowStart = rqStart;
    var rq = this.lastRq;
    //
    this.showPreloader(true);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onCallHandler.bind(this));
  }

  onSearch(key, e) {
    //e.preventDefault();
    if (key) {
      if (!(e.which == 13)) return;
    }
    var $search = $(".wlfInputText").val();
    // console.log("onSearch", $search);
    //this.search($search);
    var rq = {
      action: "advanced",
      collectionName: this.collectionName,
      query: Solr.QueryWrapper.toJsonObject(this.query),
      options: {
        IncludeChilds: true,
        IncludeRelations: 2,
        FilterRelations: null,
        RowStart: 0,
        RowsNum: 100,
        OrderBy: "id desc",
        Fields: "*",
      },
    };
    console.log(rq);
    this.lastRq = rq;
    this.showPreloader(true);
    thatServiceManeger.standardCall("/api/solr/" + rq.action, rq, this.onCallHandler.bind(this));
  }

  onCallHandler(rs) {
    this.showPreloader(false);
    console.log(rs);
    if (!rs.Success) {
      this.lastRq = null;
      //
      $(".wlfTotalRows").text();
      $(".wlfPageSize").text();
      $(".wlfPageRows").text();
      $(".wlfRowStart").text();
      $(".wlfRows").text("");
      //
      alert("Error");
      return;
    }
    // mi setto il total rows nella request (per il paging)
    this.lastRq.TotalRows = rs.TotalRows;
    //
    $(".wlfTotalRows").text(rs.TotalRows);
    $(".wlfPageSize").text(this.lastRq.options.RowsNum);
    $(".wlfPageRows").text(rs.Rows.length);
    $(".wlfRowStart").text(rs.RowStart);
    $(".wlfRows").text("");
    //
    var i = 0;
    for (var o of rs.Rows) {
      //var row = $("<texarea cols='300' rows='10' style='background-color:"+(i%2==0 ? "#EEEEEE" : "#FFFFFF")+"'></texarea>");
      var row = $("<span  style='background-color:" + (i % 2 == 0 ? "#EEEEEE" : "#FFFFFF") + "'></span>");
      var text = JSON.stringify(o /*, null, 2*/);
      row.text(rs.RowStart + i + "\t" + text);
      $(".wlfRows").append(row);
      $(".wlfRows").append("<br>");
      i++;
    }
  }
}
